<div class="filter-list" [class.filter-list--compact]="compact">
  <!-- Fuel -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Fuel</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="fuel100LLFilter" label="100LL" [compact]="compact" (change)="fuelChange($event, '100LL')">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="fuelJetAFilter" label="Jet-A" [compact]="compact" (change)="fuelChange($event, 'JetA')">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="fuelMOGASFilter" label="MOGAS" [compact]="compact" (change)="fuelChange($event, 'MOGAS')">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="fuelUL94Filter" label="UL94" [compact]="compact" (change)="fuelChange($event, 'UL94')">
      </app-checkbox-filter>
    </div>
  </div>

  <!-- Runway Specs -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Runway Specs</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.PavedRunway)" label="Paved Runway"
                           svgIcon="amenities:paved" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Grass)" label="Grass Strip"
                           svgIcon="amenities:grass" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Helipad)" label="Helipad"
                           svgIcon="amenities:helipad" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Waterway)" label="Waterway"
                           svgIcon="amenities:waterway" [compact]="compact">
      </app-checkbox-filter>
      <app-number-filter [filter]="rwyLenFilter" label="Min Runway Length" [(ngModel)]="rwyLenFilter.length"
                         svgIcon="amenities:runway_length" inputLabel="Length:" inputSuffix="ft" [compact]="compact">
      </app-number-filter>
    </div>
  </div>

  <!-- Airport Amenities -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Airport Amenities</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.PublicUse)" label="Public Use" fontSet="fa"
                           (change)="onPublicUseChanged()" fontIcon="fa-globe" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Towered)" label="Towered"
                           svgIcon="amenities:towered" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.NoLandingFee)" label="No Landing Fee"
                           icon="money_off" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Restaurant)" label="Restaurant on Field"
                           svgIcon="amenities:restaurant" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.CourtesyCar)" label="Courtesy Car"
                           svgIcon="amenities:courtesy_car" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.RentalCar)" label="Rental Car"
                           icon="directions_car" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Customs)" label="Customs"
                           icon="flag" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Oxygen)" label="Oxygen"
                           svgIcon="amenities:oxygen" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.Camping)" label="Camping on Field"
                           svgIcon="amenities:camping" [compact]="compact">
      </app-checkbox-filter>
    </div>
  </div>

  <!-- Approach Types -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Approach Types</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="ilsApproachFilter" label="ILS"[compact]="compact"></app-checkbox-filter>
      <app-checkbox-filter [filter]="rnavApproachFilter" label="RNAV"[compact]="compact"></app-checkbox-filter>
      <app-checkbox-filter [filter]="vorApproachFilter" label="VOR"[compact]="compact"></app-checkbox-filter>
    </div>
  </div>

  <!-- Maintenance -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Maintenance</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="airframeRepairFilter" label="Airframe Repair"
                           svgIcon="amenities:airframe" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="engineRepairFilter" label="Engine Repair"
                           svgIcon="amenities:engine" [compact]="compact">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="avionicsRepairFilter" label="Avionics Repair"
                           icon="radio" [compact]="compact">
      </app-checkbox-filter>
    </div>
  </div>
</div>
